<template>
  <q-page>
    <div>  
      <AssignWorkJournal type="open"></AssignWorkJournal>
      <AssignWork></AssignWork>  
      <AssignWorkJournal type="last"></AssignWorkJournal> 
    </div>
  </q-page>
</template>

<script>
import { date } from 'quasar'
import AssignWork from '@/components/assign/AssignWork.vue'
import AssignWorkJournal from '@/components/assign/AssignWorkJournal.vue'
export default {
  name: 'Distribute',
  components: {
    AssignWork,
    AssignWorkJournal,
  },
  data: function () {
    return {
      
    }
  }
}
</script>
<style scoped>
.content{
  padding: 10px;
}
</style>
